import { render, staticRenderFns } from "./HistoricalCompetitionCard.vue?vue&type=template&id=7ac7f90f&scoped=true"
import script from "./HistoricalCompetitionCard.vue?vue&type=script&lang=js"
export * from "./HistoricalCompetitionCard.vue?vue&type=script&lang=js"
import style0 from "./HistoricalCompetitionCard.vue?vue&type=style&index=0&id=7ac7f90f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ac7f90f",
  null
  
)

export default component.exports